<script lang="ts" setup="">
import { storeToRefs } from 'pinia'
import { useToastStore } from '@/store/toast.ts'

const { toasts } = storeToRefs(useToastStore())
const { removeToast } = useToastStore()
</script>

<template>
  <Teleport to="body">
    <div class="fixed bottom-12 left-1/2 z-50 grid -translate-x-1/2 grid-cols-1">
      <TransitionGroup name="list">
        <div
          v-for="toast in toasts"
          :key="toast.id"
          class="h-[94px] will-change-transform"
        >
          <VNotification
            :icon="toast.icon"
            :text="toast.text"
            :title="toast.title"
            :variant="toast.variant"
            clickable
            elevated
            data-test="notification"
            @click="removeToast(toast.id)"
          />
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<style>
.list-leave-active {
  transition:
    opacity 150ms ease-in-out,
    height 150ms 150ms ease-in-out;
}

.list-enter-active {
  transition: all 200ms cubic-bezier(0.34, 1.56, 0.64, 1);
}

.list-enter-from {
  height: 0;
  opacity: 0;
  transform: scale(0.9);
}

.list-enter-to {
  height: 94px;
}

.list-leave-from {
  opacity: 1;
}

.list-leave-to {
  opacity: 0;
  height: 0;
}
</style>
